import classNames from 'classnames';
import { Toaster, resolveValue } from 'react-hot-toast';

import Error from '@/assets/icons/toast-error.svg?react';

import MellowMark from '../../../../toolkit/core-kit/assets/mellow-mark.svg?react';

import styles from './index.module.scss';

function Toast() {
  return (
    <Toaster
      toastOptions={{
        className: styles.toast,
        success: {
          className: classNames(styles.toast, styles.success),
          icon: <MellowMark aria-hidden />,
        },
        error: {
          className: classNames(styles.toast, styles.error),
          icon: <Error />,
        },
      }}
    >
      {(toastInstance) => (
        <div {...toastInstance.ariaProps} className={toastInstance.className}>
          <div className={styles.image}>{toastInstance.icon}</div>
          <div className={styles.message}>{resolveValue(toastInstance.message, toastInstance)}</div>
        </div>
      )}
    </Toaster>
  );
}

export default Toast;
